export default __webpack_public_path__ + "static/media/Binance-USD-BUSD-The-Giving-Block.3470fa8f.png";